import {SystemActionEnum, SetInitialLocationAction} from "./types";

export const SystemActionCreators = {
    setInitialLocation: (payload: string): SetInitialLocationAction => ({
        type: SystemActionEnum.SET_INITIAL_LOCATION,
        payload
    }),
}
